// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "html {\n  background-color: #0061bd;\n}", "",{"version":3,"sources":["/vercel/path0/src/styles.scss","styles.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;ACCJ","file":"styles.scss","sourcesContent":["html{\n    background-color: rgb(0, 97, 189);\n}","html {\n  background-color: #0061bd;\n}"]}]);
// Exports
module.exports = exports;
